import { create } from "zustand"
import { persist, createJSONStorage } from "zustand/middleware"
import { ProfileCommunity } from "@/app/entities/BFF/ProfileShort"
import { BlockUser } from "@/app/entities/BFF/BlockUser"

interface BlcokUserProfileState {
  profiles: ProfileCommunity[] | null
  setProfiles: (data: ProfileCommunity[]) => void
  deleteProfile: (profileId: string) => void
  clearProfiles: () => void
}

export const useBlockProfilesStore = create<BlcokUserProfileState>()(
  persist(
    (set) => ({
      profiles: null,
      setProfiles: (data) => set({ profiles: data }),
      deleteProfile: (profileId) =>
        set((state) => ({
          profiles: state.profiles
            ? state.profiles.filter((profile) => profile.id !== profileId)
            : null,
        })),
      clearProfiles: () => set({ profiles: null }),
    }),
    {
      name: "my-block-profiles-store",
      storage: createJSONStorage(() => sessionStorage),
      partialize: (state) => ({
        profiles: state.profiles,
      }),
    },
  ),
)

interface BlockUsersState {
  blockUsers: BlockUser[]
  setBlockUsers: (data: BlockUser[]) => void
  clearBlockUsers: () => void
  addBlockUser: (blockUser: BlockUser) => void
  deleteBlockUser: (profileId: string) => void
  isLoading: boolean | null
  setIsLoading: (loading: boolean) => void
  checkBlocked: (profileId: string) => boolean
}

export const useBlockUsersStore = create<BlockUsersState>()(
  persist(
    (set, get) => ({
      blockUsers: [],
      setBlockUsers: (data) => set({ blockUsers: data }),
      clearBlockUsers: () => set({ blockUsers: [] }),
      addBlockUser: (blockUser) =>
        set((state) => ({
          blockUsers: [...state.blockUsers, blockUser],
        })),
      deleteBlockUser: (id) =>
        set((state) => ({
          blockUsers: state.blockUsers.filter((user) => user.id !== id),
        })),
      isLoading: null,
      setIsLoading: (loading) => set({ isLoading: loading }),
      checkBlocked: (profileId) => {
        const { blockUsers } = get()
        return blockUsers.some((blockUser) => blockUser.profileId === profileId)
      },
    }),
    {
      name: "my-block-users-store",
      storage: createJSONStorage(() => sessionStorage),
      partialize: (state) => ({
        blockUsers: state.blockUsers,
      }),
    },
  ),
)
